import React from 'react';
import { ArrowRightIcon } from 'lucide-react';
import { cn } from '../lib/utils';
type Props = {
  children: React.ReactNode;
  className?: string;
  href?: string;
  size?: 'md' | 'lg';
};
export const CHECKOUT_URL = 'https://il-sistema-triathlon-full-distance.impultienda.ar/checkout';
export function CTAButton({
  children,
  className = '',
  href = CHECKOUT_URL,
  size = 'lg'
}: Props) {
  const pad = size === 'lg' ? 'min-h-[62px] px-5 py-3 text-[15px] sm:px-7 sm:text-lg' : 'min-h-[56px] px-5 py-3 text-[15px]';
  return <a href={href} className={cn('group inline-flex w-full max-w-[420px] items-center justify-center gap-2 rounded-xl leading-tight bg-electric text-center font-bold uppercase tracking-wide text-white', 'shadow-[0_14px_32px_-12px_rgba(20,125,255,0.65),inset_0_-2px_0_rgba(0,0,0,0.18)]', 'transition-[transform,background-color,box-shadow] duration-200 ease-out hover:-translate-y-0.5 hover:bg-electric-deep active:translate-y-0', 'focus:outline-none focus-visible:ring-2 focus-visible:ring-white focus-visible:ring-offset-2 focus-visible:ring-offset-electric', pad, className)} data-id="element-56" data-mp="2ozhzjhjpndti">
      {children}
      <ArrowRightIcon className="h-5 w-5 shrink-0 transition-transform duration-200 ease-out group-hover:translate-x-1" aria-hidden="true" data-id="element-57" data-mp="1i9bh94w3ojne" />
    </a>;
}